/* eslint-ignore */
// @ts-nocheck
import { Form } from 'formik';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 215px;
  width: 100%;
  max-width: 370px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const ContainerButtons = styled.div`
  max-width: 370px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  display: grid;
  row-gap: 10px;
  margin-bottom: 20px;
  a {
    text-decoration: none;
    width: 100%;
  }
`;

export const FormContainer = styled(Form)`
  margin-top: 45px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  max-width: 620px;
  width: 620px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  span {
    color: ${({ theme }) => theme.colors.darkBlue};
    font-size: 20px;
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
  }

  margin-bottom: 36px;
`;

export const ModalBody = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  max-width: 536px;
  margin-bottom: 36px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 1rem;
  span {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 21px;
  }

  a {
    color: ${({ theme }) => theme.colors.darkBlue};
    text-decoration: none;
    cursor: pointer;
  }
  a:first-child {
    margin-bottom: 12px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 620px;
    width: auto;
  }
`;
